module.exports = __webpack_public_path__ + "img/orange_030.d82f1548.png";